/*eslint-disable*/
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { ApiEndpoint } from "../../utils/ApiEndpoint";
import { Col, Row, Stack } from "react-bootstrap";
import * as AiIcons from "react-icons/ai";
import CampaignMessages from "./_CampaignMessages";
import DataBaseRecords from "../ContactsDatabase/_DataBaseRecords";
//import ModalEdit from "../../components/ModalEdit";
//import NewCampaignMessage from "./_NewCampaignMessage";

//import MessageDetail from "./MessageDetail";
import Confirm from "../../components/Confirm";
import { useAuth } from "../../Context/AuthContext";
import moment from "moment";
import { httpClient } from "../../utils/HttpClient";
import EmailPreview from "./_EmailPreview";
import ModalShow from "../../components/Modal";
import _ModalDetail from "../../components/modal/campaign/detail/_ModalDetail";
import _ModalEdit from "../../components/modal/campaign/detail/_ModalEdit";
const CampaignDetail = () => {
  let { id } = useParams();
  const Auth = useAuth();
  var userData = Auth.getSessionData();
  const [showAddMessage, setShowAddMessage] = useState({
    visible: false,
    data: null,
    type: null,
  });
  const [showDetailMessage, setShowDetailMessage] = useState({
    visible: false,
    data: null,
    type: null,
  });
  const [showPreview, setShowPreview] = useState(false);
  const [uidDatabase, setUidDatabase] = useState(false);
  const [campaignInfo, setCampaignInfo] = useState(null);
  const [campaignMessages, setCampaignMessages] = useState(null);
  const [idRecordToDetail, setIdRecordToDetail] = useState(false);
  const [idRecordMessageToDelete, setIdRecordMessageToDelete] = useState(false);
  const [showConfirmCancel, setShowConfirmCancel] = useState(false);

  const [status, setStatus] = useState(null);
  const [nameCampaign, setNameCampaign] = useState(null);
  const [messagePreview, setMessagePreview] = useState(null);

  const handleClose = () => {
    console.log("entre a handlecolse");
    setShowAddMessage({
      visible: false,
      data: null,
      type: null,
    });
    setShowDetailMessage({
      visible: false,
      data: null,
      type: null,
    }); /*******/
    getCampaign();
    getCampaignMessages();
  };
  const handleClosePreview = () => {
    setShowPreview(false);
    setMessagePreview("");
  };

  const InactivateMessage = () => {
    const URIDb =
      ApiEndpoint +
      "campaigns/inactivateCampaignMessage/" +
      idRecordMessageToDelete;

    httpClient("DELETE", URIDb, {}, userData.token)
      .then(() => {
        getCampaign();
        setShowConfirmCancel(false);
        getCampaignMessages();
      })
      .catch(function (error) {
        console.log(error);
      });
  };
  const handleShowMessage = () =>
    setShowAddMessage({
      visible: true,
      data: null,
      type: null,
    });
  const handleShowPreview = () => setShowPreview(true);
  const handleShowDetailMessage = () =>
    setShowDetailMessage({
      visible: true,
      data: null,
      type: null,
    });

  const getCampaign = () => {
    const URI = ApiEndpoint + "campaigns/getPartnerCampaign/";

    httpClient("GET", URI + id, {}, userData.token).then((response) => {
      setCampaignInfo(response.data[0]);
      setUidDatabase(`${response.data[0].uid_database}`);
    });
  };

  const getCampaignMessages = () => {
    const URI = ApiEndpoint + "campaigns/getPartnerCampaignMessages/";
    httpClient("GET", URI + id, {}, userData.token).then((response) => {
      setCampaignMessages(response.data);
    });
  };

  useEffect(() => {
    getCampaign();
    getCampaignMessages();
  }, []);

  return (
    <>
      {campaignInfo && (
        <>
          <div className="">
            <h2>Detalles de Campaña</h2>
            <div className="flex justify-between items-center my-2">
              <h4>Información</h4>
              <div className="flex justify-end gap-2 border rounded-lg px-4 py-2 bg-white">
                <span className="text-gray-600 font-bold text-md">
                  {campaignInfo.vc_partner}
                </span>{" "}
                |{" "}
                <span className="text-gray-600 font-semibold text-md">
                  {campaignInfo.vc_user}
                </span>
              </div>
            </div>
           
            <div className="grid grid-cols-[repeat(auto-fit,minmax(180px,1fr))] gap-4">
              <div className="DbDetails1">
                  <Stack direction="horizontal" gap={2}>
                    <AiIcons.AiOutlineDatabase />
                    <div className="ms-auto">
                      <p>{campaignInfo.vc_campaignname}</p>
                    </div>
                  </Stack>
                  <div className="details">Nombre</div>
                </div>
           
           
            
                <div className="DbDetails2">
                  <Stack direction="horizontal" gap={2}>
                    <AiIcons.AiOutlineNumber />
                    <div className="ms-auto">
                      <p>
                        {campaignInfo.i_totalmessages} /{" "}
                        {campaignInfo.i_contacts}
                      </p>
                    </div>
                  </Stack>
                  <div className="details">Mensajes / Contactos </div>
                </div>
              
            
                <div className="DbDetails3">
                  <Stack direction="horizontal" gap={2}>
                    <AiIcons.AiOutlineCalendar />
                    <div className="ms-auto">
                      <p>
                        {moment(campaignInfo.tst_create).format("DD/MM/YYYY")}
                      </p>
                    </div>
                  </Stack>
                  <div className="details">Fecha de creación</div>
                </div>
             
                <div className="DbDetails3">
                  <Stack direction="horizontal" gap={2}>
                    <AiIcons.AiOutlineCalendar />
                    <div className="ms-auto">
                      <p>{campaignInfo.vc_mask}</p>
                    </div>
                  </Stack>
                  <div className="details">Mascara</div>
                </div>
              
                <div
                  className={
                    campaignInfo.b_active
                      ? "DbDetailsStatusON"
                      : "DbDetailsStatusOFF"
                  }
                >
                  <Stack direction="horizontal" gap={2}>
                    <AiIcons.AiOutlineFlag />
                    <div className="ms-auto">
                      <p>{campaignInfo.b_active ? "Active" : "Inactiva"}</p>
                    </div>
                  </Stack>
                  <div className="details">Estatus</div>
                </div>
              </div>
            <div className="wrapp">
              {campaignMessages && (
                <CampaignMessages
                  setShow={setShowAddMessage}
                  setShowDetail={setShowDetailMessage}
                  dataBaseInfo={campaignMessages}
                  setIdRecord={() => {}}
                  setIdRecordToDetail={setIdRecordToDetail}
                  setIdRecordMessageToDelete={setIdRecordMessageToDelete}
                  setShowConfirmCancel={setShowConfirmCancel}
                  setStatus={setStatus}
                  setNameCampaign={setNameCampaign}
                  isDatabaseDeleted={campaignInfo.b_deleted}
                  setShowPreview={setShowPreview}
                  setMessagePreview={setMessagePreview}
                />
              )}
            </div>
            <div className="wrapp">
              <DataBaseRecords
                totalRecords={campaignInfo.i_contacts}
                uidDatabase={uidDatabase}
                idpartnerdatabase={campaignInfo.id_partnerdatabase}
                isHidden={campaignInfo.b_deleted || campaignInfo.b_hidden}
              />
              {/* <ModalEdit
                show={showAddMessage.visible}
                handleShow={handleShowMessage}
                handleClose={handleClose}
                title="Agregar Mensaje"
                type={showAddMessage.type}
              >
                <NewCampaignMessage
                  CampaignName={`${campaignInfo.vc_campaignname}`}
                  uidCampaign={`${id}`}
                  handleCloseParent={handleClose}
                  uidDatabase={uidDatabase}
                  type={showAddMessage.type}
                />
              </ModalEdit> */}
              <_ModalEdit
                visible={showAddMessage.visible}
                onClose={handleClose}
                title="Agregar Mensaje"
                type={showAddMessage.type}
                data={{
                  uidCampaign: `${id}`,
                  uidDatabase: `${uidDatabase}`,
                  CampaignName: `${campaignInfo.vc_campaignname}`,
                  type: showAddMessage.type,
                }}
              />
              <_ModalDetail
                visible={showDetailMessage.visible}
                title="Detalles"
                type={showDetailMessage.type}
                onClose={handleClose}
                data={{
                  uidCampaign: `${id}`,
                  idCampaignMessage: idRecordToDetail,
                  idStatus: status,
                  nameCampaign: nameCampaign,
                }}
              />
              <ModalShow
                show={showPreview}
                handleShow={handleShowPreview}
                handleClose={handleClosePreview}
                title="Vista Previa de Correo"
                placement="start"
                size={"xl"}
              >
                <EmailPreview message={messagePreview}></EmailPreview>
              </ModalShow>
              <Confirm
                show={showConfirmCancel}
                handleClose={() => setShowConfirmCancel(false)}
                message={"Desea cancelar el mensaje seleccionado?"}
                handleConfirm={InactivateMessage}
              />
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default CampaignDetail;
